module.exports = __webpack_public_path__ + "img/619.Coffee_cooling_malfunction.97a68f96.svg";